
import { Vue } from 'vue-property-decorator'
import store from '../store'
import Component from 'vue-class-component'

@Component
export default class AdminRouteCheck extends Vue {
  get queryOverride (): boolean {
    return this.$route.query.admin === 'true' && this.isAdmin
  }

  get isAdmin (): boolean {
    return store.state.user.authenticatedUser?.admin ?? false
  }

  get authenticatedUser () {
    return store.getters.user.authenticatedUser
  }
}
